export const FETCH_PACKAGES = "app/Package/FETCH_PACKAGES";
export const FETCH_PACKAGES_SUCCESS = "app/Package/FETCH_PACKAGES_SUCCESS";
export const FETCH_PACKAGES_FAILURE = "app/Package/FETCH_PACKAGES_FAILURE";

export const SET_CART_DATA = "app/Package/SET_CART_DATA";

export const TOGGLE_CONFIRM_MODAL = "app/Package/TOGGLE_CONFIRM_MODAL";

export const CREATE_PAYMENT = "app/Package/CREATE_PAYMENT";
export const CREATE_PAYMENT_SUCCESS = "app/Package/CREATE_PAYMENT_SUCCESS";
export const CREATE_PAYMENT_FAILURE = "app/Package/CREATE_PAYMENT_FAILURE";

export const ADD_TRANSACTION = "app/Package/ADD_TRANSACTION";
export const ADD_TRANSACTION_SUCCESS = "app/Package/ADD_TRANSACTION_SUCCESS";
export const ADD_TRANSACTION_FAILURE = "app/Package/ADD_TRANSACTION_FAILURE";
